import script from "./jianchadetail.vue?vue&type=script&setup=true&lang=js"
export * from "./jianchadetail.vue?vue&type=script&setup=true&lang=js"

import "./jianchadetail.vue?vue&type=style&index=0&id=4aef96b4&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aef96b4"]])

export default __exports__